import contextData from '../../contextData';
import fileSizeFormatter from '../../Utils/fileSizeFormatter';
import template from './fileUploadSelecter.html';

export function FileUploadSelecterViewModel(params) {

  var self = this;
  var addFileUploadsCallback = params.addFileUploadsCallback;

  self.maximumUploadSize = contextData.portalSettings.maximumUploadSize;

  self.formattedMaximumUploadSize =
    fileSizeFormatter.getFormattedFileSize(contextData.portalSettings.maximumUploadSize);

  self.addFileUploads = function (fileList) {
    addFileUploadsCallback(fileList);
  };

  self.isDirectorySupported = isDirectorySupported();

  function isDirectorySupported() {
    var tmpInput = document.createElement('input');
    if ('webkitdirectory' in tmpInput ||
      'mozdirectory' in tmpInput ||
      'odirectory' in tmpInput ||
      'msdirectory' in tmpInput ||
      'directory' in tmpInput) {
      return true;
    }

    return false;
  }
}

// The default export returns the component details object to register with KO
export default { viewModel: FileUploadSelecterViewModel, template: template };
